import { useState } from 'react';
import {
  InputLabel,
  Button,
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  Box,
  InputAdornment,
} from '@mui/material';
import { jidsConsumableSupply } from '../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';
import RetailerLookupButton from '../retailerLookupButton.js';
import axios from 'axios';
import SupplySelectModal from './supplySelectModal/supplySelectModal.js';

const ConsumableSupplyForm = ({
  translations,
  user,
  handleFormSelectionReset,
  setSnackbarMessage,
  setIsSnackbarOpen,
  setSnackbarSeverity,
}) => {
  const [form, setForm] = useState({
    jurisdiction: '',
    retailerId: '',
    retailerName: '',
    address: '',
    phoneNumber: '',
    callerName: '',
    supplySelections: {
      adjustmentForms: '',
      allOrNothing: '',
      badger5: '',
      cash3: '',
      cash4: '',
      cash5: '',
      cash5EzMatch: '',
      cashball: '',
      cashPop: '',
      cashPopPlay: '',
      claimForms: '',
      classicLotto47: '',
      clubKenoJack: '',
      daily3: '',
      daily4: '',
      daily5: '',
      dailyDerby: '',
      dailyKeno: '',
      envelopes: '',
      fantasy5: '',
      gaCashPop: '',
      georgia5: '',
      gopher5: '',
      hit5: '',
      hotSpot: '',
      instantShowcaseRolls: '',
      instantTicketTrackingForms: '',
      itvmRolls: '',
      jerseyCash5: '',
      keno: '',
      kenoPencils: '',
      kenoToGo: '',
      kentucky5: '',
      lotto: '',
      lottoAmerica: '',
      lottoExtra: '',
      match4: '',
      match5: '',
      megaBucks: '',
      megaMillions: '',
      millionaireForLife: '',
      moMillions: '',
      ncKenoMultiplier: '',
      newKenoRefresh: '',
      njCashPop4Board: '',
      northstar5: '',
      numbers: '',
      palmettoCash5: '',
      pencils: '',
      perforatedTape: '',
      pick10: '',
      pick2: '',
      pick3: '',
      pick4: '',
      pick5: '',
      pick6: '',
      powerball: '',
      powerballXsOs: '',
      quickBucks: '',
      quickDraw: '',
      quickDrawQuickDrawExtra: '',
      quickDrawBullseye: '',
      returnBags: '',
      showMeCash: '',
      superCash: '',
      superLottoPlus: '',
      take5: '',
      thermalTicketStock: '',
      ticketStock: '',
      tnCash: '',
      tnDailyJackpot: '',
      tripleJackpotPlay: '',
      ultraTicketStock: '',
      win4: '',
    },
    supplyChangeComments: '',
    email: user.email,
    emailAddress: user.email,
    displayName: user.displayName,
    userId: user.userId,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSupplySelectModalOpen, setIsSupplySelectModalOpen] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });

    if (name === 'jurisdiction') {
      setForm(prevForm => ({
        ...prevForm,
        supplySelections: {
          adjustmentForms: '',
          allOrNothing: '',
          badger5: '',
          cash3: '',
          cash4: '',
          cash5: '',
          cash5EzMatch: '',
          cashball: '',
          cashPop: '',
          cashPopPlay: '',
          claimForms: '',
          classicLotto47: '',
          clubKenoJack: '',
          daily3: '',
          daily4: '',
          daily5: '',
          dailyDerby: '',
          dailyKeno: '',
          envelopes: '',
          fantasy5: '',
          gaCashPop: '',
          georgia5: '',
          gopher5: '',
          hit5: '',
          hotSpot: '',
          instantShowcaseRolls: '',
          instantTicketTrackingForms: '',
          itvmRolls: '',
          jerseyCash5: '',
          keno: '',
          kenoPencils: '',
          kenoToGo: '',
          kentucky5: '',
          lotto: '',
          lottoAmerica: '',
          lottoExtra: '',
          match4: '',
          match5: '',
          megaBucks: '',
          megaMillions: '',
          millionaireForLife: '',
          moMillions: '',
          ncKenoMultiplier: '',
          newKenoRefresh: '',
          njCashPop4Board: '',
          northstar5: '',
          numbers: '',
          palmettoCash5: '',
          pencils: '',
          perforatedTape: '',
          pick10: '',
          pick2: '',
          pick3: '',
          pick4: '',
          pick5: '',
          pick6: '',
          powerball: '',
          powerballXsOs: '',
          quickBucks: '',
          quickDraw: '',
          quickDrawQuickDrawExtra: '',
          quickDrawBullseye: '',
          returnBags: '',
          showMeCash: '',
          superCash: '',
          superLottoPlus: '',
          take5: '',
          thermalTicketStock: '',
          ticketStock: '',
          tnCash: '',
          tnDailyJackpot: '',
          tripleJackpotPlay: '',
          ultraTicketStock: '',
          win4: '',
        },
      }));
    }
  };

  const handleSupplySelectModalOpenClose = () => {
    setIsSupplySelectModalOpen(!isSupplySelectModalOpen);
  };

  const handleClear = () => {
    setForm({
      ...form,
      jurisdiction: '',
      retailerId: '',
      retailerName: '',
      address: '',
      phoneNumber: '',
      callerName: '',
      supplySelections: {
        adjustmentForms: '',
        allOrNothing: '',
        badger5: '',
        cash3: '',
        cash4: '',
        cash5: '',
        cash5EzMatch: '',
        cashball: '',
        cashPop: '',
        cashPopPlay: '',
        claimForms: '',
        classicLotto47: '',
        clubKenoJack: '',
        daily3: '',
        daily4: '',
        daily5: '',
        dailyDerby: '',
        dailyKeno: '',
        envelopes: '',
        fantasy5: '',
        gaCashPop: '',
        georgia5: '',
        gopher5: '',
        hit5: '',
        hotSpot: '',
        instantShowcaseRolls: '',
        instantTicketTrackingForms: '',
        itvmRolls: '',
        jerseyCash5: '',
        keno: '',
        kenoPencils: '',
        kenoToGo: '',
        kentucky5: '',
        lotto: '',
        lottoAmerica: '',
        lottoExtra: '',
        match4: '',
        match5: '',
        megaBucks: '',
        megaMillions: '',
        millionaireForLife: '',
        moMillions: '',
        ncKenoMultiplier: '',
        newKenoRefresh: '',
        njCashPop4Board: '',
        northstar5: '',
        numbers: '',
        palmettoCash5: '',
        pencils: '',
        perforatedTape: '',
        pick10: '',
        pick2: '',
        pick3: '',
        pick4: '',
        pick5: '',
        pick6: '',
        powerball: '',
        powerballXsOs: '',
        quickBucks: '',
        quickDraw: '',
        quickDrawQuickDrawExtra: '',
        quickDrawBullseye: '',
        returnBags: '',
        showMeCash: '',
        superCash: '',
        superLottoPlus: '',
        take5: '',
        thermalTicketStock: '',
        ticketStock: '',
        tnCash: '',
        tnDailyJackpot: '',
        tripleJackpotPlay: '',
        ultraTicketStock: '',
        win4: '',
      },
      supplyChangeComments: '',
    });
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      await axios({
        method: 'POST',
        url: `${process.env.REACT_APP_ENDPOINT_FORMS}/uscc/consply/submit`,
        data: {
          ...form,
        },
      });
      setSnackbarMessage('Form submitted successfully!');
      setSnackbarSeverity('success');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
      handleClear();
      handleFormSelectionReset();
    } catch (error) {
      console.error('Error submitting form:', error);
      setSnackbarMessage(
        'There was an error submitting the form. Please try again. If the problem persists, contact support.'
      );
      setSnackbarSeverity('error');
      setIsSnackbarOpen(true);
      setIsSubmitting(false);
    }
  };

  const isFormValid = () => {
    const {
      jurisdiction,
      retailerId,
      retailerName,
      address,
      phoneNumber,
      callerName,
    } = form;

    if (
      !jurisdiction ||
      !retailerId ||
      !retailerName ||
      !address ||
      !phoneNumber ||
      !callerName
    ) {
      return false;
    }

    return true;
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{
          display: 'flex',
          justifyItems: 'center',
          width: { xs: 'auto', md: 'var(--forms-layout-width, 90vw)' },
        }}
      >
        <Grid size={{ xs: 12, md: 6 }}>
          <FormControl
            required
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          >
            <InputLabel>
              {translations.jurisdiction || 'Jurisdiction'}
            </InputLabel>
            <Select
              value={form.jurisdiction}
              label={translations.jurisdiction || 'Jurisdiction'}
              onChange={handleChange}
              name='jurisdiction'
              endAdornment={
                <InputAdornment position='end'>
                  <Button
                    variant={'contained'}
                    disabled={!form.jurisdiction}
                    onClick={handleSupplySelectModalOpenClose}
                    sx={{
                      backgroundColor: 'var(--procyon-green)',
                      color: '#000000',
                      fontFamily: 'BrightstarSans-Regular',
                    }}
                  >
                    Select Supply
                  </Button>
                </InputAdornment>
              }
            >
              {jidsConsumableSupply.map(jid => (
                <MenuItem value={jid}>{jid}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label='Retailer Name'
            name='retailerName'
            required
            value={form.retailerName}
            onChange={handleChange}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
          <TextField
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
            value={form.phoneNumber}
            onChange={handleChange}
            label='Phone Number'
            name='phoneNumber'
            required
          />
          <TextField
            label='Associate Name'
            disabled
            value={`${user.firstName} ${user.lastName}`}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Tooltip
            title={'Enter a Retailer ID (numeric values only) to lookup'}
            arrow
          >
            <TextField
              label='Retailer ID'
              required
              name='retailerId'
              fullWidth
              value={form.retailerId}
              onChange={handleChange}
              sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
              type='number'
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position='end'>
                      <RetailerLookupButton form={form} setForm={setForm} />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Tooltip>
          <TextField
            label='Address'
            name='address'
            required
            value={form.address}
            onChange={handleChange}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
          <TextField
            required
            label='Caller Name'
            name='callerName'
            fullWidth
            value={form.newPhone}
            onChange={handleChange}
            sx={{ backgroundColor: '#ffffff', marginBottom: '15px' }}
          />
          <TextField
            label='Supply Change Comments'
            name='supplyChangeComments'
            value={form.supplyChangeComments}
            onChange={handleChange}
            multiline
            rows={4.1}
            sx={{
              backgroundColor: '#ffffff',
              marginBottom: '15px',
              width: '100%',
            }}
          />
        </Grid>
        <Grid
          size={12}
          sx={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            variant='contained'
            sx={{
              backgroundColor: 'var(--aldebaran-yellow)',
              color: '#000000',
              fontFamily: 'BrightstarSans-Regular',
              width: '10%',
            }}
            onClick={handleClear}
          >
            Clear
          </Button>
          <Tooltip
            title={
              !isFormValid()
                ? 'Please fill in all required fields to enable the Submit button'
                : ''
            }
            arrow
          >
            <Box>
              <Button
                disabled={!isFormValid() || isSubmitting}
                variant='contained'
                sx={{
                  backgroundColor: 'var(--vega-blue)',
                  fontFamily: 'BrightstarSans-Regular',
                  width: '100%',
                }}
                onClick={handleSubmit}
                loading={isSubmitting}
              >
                {'Submit'}
              </Button>
            </Box>
          </Tooltip>
        </Grid>
      </Grid>
      {isSupplySelectModalOpen && (
        <SupplySelectModal
          isOpen={isSupplySelectModalOpen}
          handleClose={handleSupplySelectModalOpenClose}
          jid={form.jurisdiction}
          supplySelections={form.supplySelections}
          setForm={setForm}
        />
      )}
    </>
  );
};

export default ConsumableSupplyForm;
